/* eslint-disable react/prop-types, react/jsx-handler-names */

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import _ from "lodash";
import { Checkbox, FormControlLabel, InputLabel, Grid, MenuItem, TextField, Typography } from "@material-ui/core";
import inputComponentMask from "lib/inputMask";
import ViewOnlyField from "components/Global/Fields/ViewOnlyField";
import { CloseButton } from "components/Global/Buttons";

const styles = theme => ({
  input: {
    display: "flex",
    padding: 0
  },
  label: {
    fontWeight: "bold",
    color: "black"
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
    fontSize: "17px"
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  placeholder: {
    position: "absolute",
    left: 2,
    fontSize: "17px"
  },
  textField: {
    borderBottom: "none !important",
    fontSize: "17px",
    transition: "none",
    "&:hover": {
      cursor: "pointer",
      transition: "none !important"
    },
    "div::before": {
      borderBottom: "1px solid #2196F3",
      transition: "none !important"
    },
    padding: "0"
  }
});

const RemoveLenderButton = styled(CloseButton)` && { color: #2196F3; } `;
const NoOptionsMessage = props => (<Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
  {" "}
  {props.children}
  {" "}
</Typography>);
function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}
const Control = props => (<TextField fullWidth InputProps={{ inputComponent, inputProps: { className: props.selectProps.classes.input, inputRef: props.innerRef, children: props.children, ...props.innerProps } }} {...props.selectProps.textFieldProps} />);
const Option = props => (<MenuItem buttonRef={props.innerRef} selected={props.isFocused} component="div" style={{ fontWeight: props.isSelected ? 500 : 400 }} {...props.innerProps}>
  {" "}
  {props.children}
  {" "}
</MenuItem>);
const Placeholder = props => (<Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
  {" "}
  {props.children}
  {" "}
</Typography>);
const ValueContainer = props => (<div className={props.selectProps.classes.valueContainer}>
  {" "}
  {props.children}
  {" "}
</div>);
const components = { Control, NoOptionsMessage, Option, Placeholder, ValueContainer };

const StyledCheckbox = styled(Checkbox)`
  && {
   margin-left: 15px;
  }
`;

const SelectContainer = styled(Grid)`
  && {
    margin-right: 10px;
  }
`;

const TextContainer = styled(TextField)`
  && {
    top: -3px;
  }
`;

class MultipleLenderInput extends React.Component {
  getlenderName(shouldShowLeadTag) {
    if (this.props.loanLenders && this.props.loanLenders.length > 0 && this.props.loanLender && this.props.loanLender.companyId) {
      const selectedOption = this.props.loanLenders.find(loanLender => loanLender.value === this.props.loanLender.companyId);

      return `${!selectedOption ? "--" : selectedOption.label} ${this.props.loanLender.isLead && shouldShowLeadTag ? "(Lead)" : ""}`;
    }

    return "--";
  }

  handleLenderSelection(selectedCompany) {
    const loanLender = this.props.loanLender;
    loanLender.companyId = selectedCompany;
    this.props.handleLoanLenderChange(loanLender, this.props.index);
  }

  handleFieldChange(name, value) {
    this.props.loanLender[name] = value;
    this.props.handleLoanLenderChange(this.props.loanLender, this.props.index);
  }

  render() {
    const selectStyles = { input: base => ({ ...base, color: this.props.theme.palette.text.primary, transition: "none", "& input": { font: "inherit" } }),
      indicatorSeparator: base => ({ ...base, display: "none" }),
      container: base => (
        { ...base,
          borderBottom: "none !important",
          fontSize: "17px",
          transition: "none",
          "&:hover": {
            cursor: "pointer",
            transition: "none !important"
          },
          "div::before": {
            borderBottom: "1px solid #2196F3",
            transition: "none !important"
          },
          padding: "0" }) };

    return (
      this.props.shouldShow && (
        <>
          <Grid item xs={3}>
            <InputLabel className={this.props.classes.label} htmlFor={this.props.name}>{this.props.label}</InputLabel>
          </Grid>

          {!this.props.isEditing && (<>
            <Grid item xs={2}><ViewOnlyField value={this.getlenderName(this.props.shouldShowLeadTag)} /></Grid>
            { this.props.shouldShowCheckboxAndAllocation > 1 && <Grid item xs={1}><ViewOnlyField mask="currencynocents" value={this.props.loanLender.lenderAllocation} /></Grid> }
                                     </>)}

          {this.props.isEditing && (<SelectContainer item xs={3}>
            <Select
              isClearable
              fullWidth
              name={`${this.props.selectName}${this.props.index}`}
              classes={this.props.classes}
              styles={selectStyles}
              options={this.props.loanLenders}
              components={components}
              onChange={(name, data) => this.handleLenderSelection(name ? name.value : null)}
              placeholder={this.props.selectPlaceholder}
              menuPlacement="auto"
              value={this.props.loanLenders.find(option => option.value === this.props.loanLender.companyId)}
            />
          </SelectContainer>)}

          <Grid item xs={3}>
            <>
              {this.props.isEditing && this.props.shouldShowCheckboxAndAllocation &&
                <TextContainer
                  id={this.props.textName}
                  name={"lenderAllocation"}
                  value={this.props.loanLender.lenderAllocation}
                  label=""
                  placeholder={this.props.textPlaceholder}
                  onChange={({ target: { name, value } }) => {
                    this.handleFieldChange(name, value);
                  }}
                  className={this.props.classes.textField}
                  InputProps={{
                    inputComponent: inputComponentMask({ mask: "currencynocents" })
                  }}
                />}

              { this.props.isEditing && this.props.shouldShowCheckboxAndAllocation &&
                <FormControlLabel
                  label="Lead"
                  labelPlacement="end"
                  control={<StyledCheckbox
                    name={"isLead"}
                    defaultChecked={this.props.loanLender.isLead}
                    onChange={({ target: { name, checked } }) => {
                      this.handleFieldChange(name, checked);
                    }}
                    disabled={this.props.hasLeadSelected && !this.props.loanLender.isLead}
                    checked={this.props.loanLender.isLead}
                  />}
                />}
              { this.props.isEditing && this.props.shouldShowRemoveButton && <RemoveLenderButton onClick={() => this.props.removeLender(this.props.index)} />}
            </>
          </Grid>

        </>
      )
    );
  }
}

MultipleLenderInput.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(MultipleLenderInput);
